import {closeCurrentDialog, openDialog} from 'platform/components';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';

import {CheckoutMessageLogDialog} from '../components/CheckoutMessageLogDialog';

export function openCheckoutMessageLogDialog(checkoutId: string) {
  openDialog(
    <CheckoutMessageLogDialog
      checkoutId={checkoutId}
      data-testid={testIds.businessCase.checkout('messageLogDialog')}
    />,
    {
      title: i18n.t('entity.checkout.labels.externalMessageLog'),
      size: 'large',
      buttons: [
        {title: i18n.t('general.actions.close'), variant: 'secondary', onClick: closeCurrentDialog},
      ],
    }
  );
}
